export var PhoneTypeEnum = {
    HOME: 'HOMEPHONE',
    MOBILE: 'MOBILEPHONE',
    WORK: 'WORKPHONE',
    FAX: 'FAXPHONE'
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/enums/phoneTypeEnum.js
// module id = 199
// module chunks = 0